// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"e9494720","642":"b5cd19bc"}[chunkId] + ".chunk.css";
};